
<app-banner [category]="category"></app-banner>
